export const ALLOCATION_TOLERANCE = 0.02
export const PAYMENT_DEADLINE_DAYS = 14
export const DEFAULT_SLIDER_PCT = 60
